import { render, staticRenderFns } from "./AuditTrail.vue?vue&type=template&id=b9c83048&scoped=true&"
import script from "./AuditTrail.vue?vue&type=script&lang=js&"
export * from "./AuditTrail.vue?vue&type=script&lang=js&"
import style0 from "./AuditTrail.vue?vue&type=style&index=0&id=b9c83048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c83048",
  null
  
)

export default component.exports